export default __webpack_public_path__ + "static/167-54cd6e78f7014402c9643bb612116e9d.gif";